import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
import { Check, Clock, ChevronDown, Utensils, Zap, Moon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Hero() {
  const [isOpen, setIsOpen] = useState(false);
  const [activePage, setActivePage] = useState<1 | 2>(1);
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <Section className="pt-8 pb-10 md:pt-12 md:pb-14 bg-[#faf8f5]" data-id="element-178">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="order-2 lg:order-1" data-id="element-180">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#d4a853]/10 text-[#2c4a2c] text-sm font-semibold mb-4 border border-[#d4a853]/20" data-id="element-181">
            <Clock className="w-4 h-4" data-id="element-182" />
            <span data-id="element-183">Objetivo: 15:00 – 21:00</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2c4a2c] leading-[1.1] mb-4 tracking-tight" data-id="element-184">
            Energía alta de 15:00 a 21:00, con{' '}
            <span className="text-[#c45d3a]" data-id="element-185">comida mediterránea</span>
          </h1>

          <p className="text-lg md:text-xl text-[#5a5a5a] mb-5 leading-relaxed max-w-xl" data-id="element-186">
            Un método simple (sin dietas extremas ni contar calorías) para
            sostener tu energía por la tarde, reducir antojos y llegar a la
            noche con ganas.
          </p>

          <div className="space-y-3 mb-5 bg-white/50 p-5 rounded-2xl border border-[#2c4a2c]/5" data-id="element-187">
            <div className="flex items-start gap-3" data-id="element-188">
              <div className="mt-1 bg-[#2c4a2c]/10 p-1 rounded-full" data-id="element-189">
                <Check className="w-4 h-4 text-[#2c4a2c]" data-id="element-190" />
              </div>
              <p className="text-[#5a5a5a]" data-id="element-191">
                Si a las 16:00 te apagas, no necesitas "más fuerza de voluntad".
                Necesitas una estructura.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-192">
              <div className="mt-1 bg-[#2c4a2c]/10 p-1 rounded-full" data-id="element-193">
                <Check className="w-4 h-4 text-[#2c4a2c]" data-id="element-194" />
              </div>
              <p className="text-[#5a5a5a]" data-id="element-195">
                Este ebook te da plantillas de comidas, micro-ajustes y un plan
                de 14 días para que tu energía deje de depender del café.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mb-4" data-id="element-196">
            <Button size="lg" className="w-full sm:w-auto text-lg shadow-xl shadow-[#2c4a2c]/10 gap-2 flex-col !h-auto py-3" onClick={() => setIsOpen(!isOpen)} data-id="element-197">
              <span className="flex items-center gap-2" data-id="element-198">
                Quiero energía alta
                <motion.span animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="inline-flex" data-id="element-199">
                  <ChevronDown className="w-5 h-5" data-id="element-200" />
                </motion.span>
              </span>
              <span className="text-xs opacity-80 font-normal" data-id="element-201">
                {isOpen ? 'Ocultar información' : 'Ver más información ↓'}
              </span>
            </Button>
            <Button variant="ghost" size="lg" className="w-full sm:w-auto" data-id="element-202">
              Ver qué incluye
            </Button>
          </div>

          <button onClick={scrollToPricing} className="text-sm text-white bg-[#c45d3a] hover:bg-[#a84a2a] px-5 py-2.5 rounded-lg cursor-pointer transition-all font-medium italic shadow-xl shadow-[#c45d3a]/40 hover:shadow-2xl hover:shadow-[#a84a2a]/50 active:scale-[0.98] hover:scale-[1.01]" data-id="element-203">
            Descarga inmediata. Enfoque mediterráneo y vida real.
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="order-1 lg:order-2 relative" data-id="element-204">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-205">
            <img src="https://cdn.magicpatterns.com/uploads/vLPjKH2LfeRDEZgDi24Zrm/heylloyd-image-mokup_energia_alta.png" alt="Mujer sonriendo mostrando el ebook Energía Alta con comida mediterránea saludable" className="w-full h-auto object-cover" data-id="element-206" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#2c4a2c]/90 to-transparent p-5 pt-16" data-id="element-207">
              <div className="flex items-center gap-2 text-white/90 text-sm font-medium" data-id="element-208">
                <span className="bg-[#d4a853] text-[#2c4a2c] px-2 py-0.5 rounded text-xs font-bold" data-id="element-209">
                  TRUST
                </span>
                <span data-id="element-210">Diseñado para mujeres ocupadas 30–50</span>
              </div>
            </div>
          </div>

          <div className="absolute -z-10 top-10 -right-10 w-64 h-64 bg-[#d4a853]/20 rounded-full blur-3xl" data-id="element-211" />
          <div className="absolute -z-10 -bottom-10 -left-10 w-64 h-64 bg-[#c45d3a]/20 rounded-full blur-3xl" data-id="element-212" />
        </motion.div>
      </div>

      {/* Contenido desplegable con toggle entre dos páginas */}
      <AnimatePresence mode="wait" data-id="element-213">
        {isOpen && <motion.div key="sistema-content" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.4,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-214">
            <div className="mt-8 bg-[#2c4a2c] text-white rounded-3xl p-6 md:p-10" data-id="element-215">
              {/* Toggle buttons para las dos páginas */}
              <div className="flex justify-center gap-2 mb-8" data-id="element-216">
                <button onClick={() => setActivePage(1)} className={`px-5 py-2.5 rounded-full font-medium transition-all cursor-pointer ${activePage === 1 ? 'bg-[#d4a853] text-[#2c4a2c]' : 'bg-[#faf8f5]/10 text-[#faf8f5] hover:bg-[#faf8f5]/20'}`} data-id="element-217">
                  Sistema en 3 Bloques
                </button>
                <button onClick={() => setActivePage(2)} className={`px-5 py-2.5 rounded-full font-medium transition-all cursor-pointer ${activePage === 2 ? 'bg-[#d4a853] text-[#2c4a2c]' : 'bg-[#faf8f5]/10 text-[#faf8f5] hover:bg-[#faf8f5]/20'}`} data-id="element-218">
                  Las 3 Palancas
                </button>
              </div>

              <AnimatePresence mode="wait" data-id="element-219">
                {activePage === 1 ? <motion.div key="page1" initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: 20
            }} transition={{
              duration: 0.3
            }} data-id="element-220">
                    <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-221">
                      <h3 className="text-2xl md:text-3xl font-bold text-[#faf8f5] mb-3" data-id="element-222">
                        La nueva forma: Sistema Energía en 3 Bloques
                      </h3>
                      <p className="text-[#faf8f5]/80" data-id="element-223">
                        Tu energía de tarde no se "desea". Se diseña con 3
                        decisiones simples cada día.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-224">
                      <div className="bg-[#faf8f5]/10 backdrop-blur-sm p-5 rounded-2xl border border-[#faf8f5]/10" data-id="element-225">
                        <div className="bg-[#d4a853] w-10 h-10 rounded-full flex items-center justify-center mb-3 text-[#2c4a2c]" data-id="element-226">
                          <Utensils className="w-5 h-5" data-id="element-227" />
                        </div>
                        <h4 className="text-lg font-bold text-[#d4a853] mb-1" data-id="element-228">
                          Bloque 1: Comida Base
                        </h4>
                        <p className="text-xs font-mono opacity-70 mb-2" data-id="element-229">
                          13:30 – 15:00
                        </p>
                        <p className="text-sm text-[#faf8f5]/90" data-id="element-230">
                          Estructura 40/30/30 para energía sostenida (sin
                          pesarte la vida).
                        </p>
                      </div>

                      <div className="bg-[#faf8f5]/10 backdrop-blur-sm p-5 rounded-2xl border border-[#faf8f5]/10 relative overflow-hidden" data-id="element-231">
                        <div className="absolute top-0 right-0 bg-[#c45d3a] text-xs font-bold px-2 py-0.5 rounded-bl-lg" data-id="element-232">
                          CLAVE
                        </div>
                        <div className="bg-[#c45d3a] w-10 h-10 rounded-full flex items-center justify-center mb-3 text-white" data-id="element-233">
                          <Zap className="w-5 h-5" data-id="element-234" />
                        </div>
                        <h4 className="text-lg font-bold text-[#c45d3a] mb-1" data-id="element-235">
                          Bloque 2: Micro-Ajuste
                        </h4>
                        <p className="text-xs font-mono opacity-70 mb-2" data-id="element-236">
                          16:00 – 17:30
                        </p>
                        <p className="text-sm text-[#faf8f5]/90" data-id="element-237">
                          El puente que evita la caída y el rescate de
                          dulce/café.
                        </p>
                      </div>

                      <div className="bg-[#faf8f5]/10 backdrop-blur-sm p-5 rounded-2xl border border-[#faf8f5]/10" data-id="element-238">
                        <div className="bg-[#8a9a8a] w-10 h-10 rounded-full flex items-center justify-center mb-3 text-[#2c4a2c]" data-id="element-239">
                          <Moon className="w-5 h-5" data-id="element-240" />
                        </div>
                        <h4 className="text-lg font-bold text-[#8a9a8a] mb-1" data-id="element-241">
                          Bloque 3: Cena Inteligente
                        </h4>
                        <p className="text-xs font-mono opacity-70 mb-2" data-id="element-242">
                          19:30 – 21:30
                        </p>
                        <p className="text-sm text-[#faf8f5]/90" data-id="element-243">
                          Energía sin pesadez y sin sabotear el descanso.
                        </p>
                      </div>
                    </div>
                  </motion.div> : <motion.div key="page2" initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} data-id="element-244">
                    <div className="bg-[#faf8f5] text-[#2c4a2c] rounded-2xl p-5 md:p-8" data-id="element-245">
                      <h4 className="text-2xl md:text-3xl font-bold mb-6 text-center" data-id="element-246">
                        Las 3 palancas que lo hacen fácil:
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center" data-id="element-247">
                        <div className="bg-[#2c4a2c]/5 p-5 rounded-2xl" data-id="element-248">
                          <div className="w-12 h-12 bg-[#2c4a2c] text-white rounded-full flex items-center justify-center mx-auto mb-3 text-xl font-bold" data-id="element-249">
                            1
                          </div>
                          <h5 className="font-bold text-lg mb-2" data-id="element-250">
                            Plato 40/30/30
                          </h5>
                          <p className="text-sm text-[#5a5a5a]" data-id="element-251">
                            Plantilla visual que te permite montar comidas
                            equilibradas sin pesar ni contar.
                          </p>
                        </div>
                        <div className="bg-[#2c4a2c]/5 p-5 rounded-2xl" data-id="element-252">
                          <div className="w-12 h-12 bg-[#2c4a2c] text-white rounded-full flex items-center justify-center mx-auto mb-3 text-xl font-bold" data-id="element-253">
                            2
                          </div>
                          <h5 className="font-bold text-lg mb-2" data-id="element-254">
                            Orden de bocado
                          </h5>
                          <p className="text-sm text-[#5a5a5a]" data-id="element-255">
                            Cómo comes cambia tu tarde. El orden correcto reduce
                            picos de glucosa.
                          </p>
                        </div>
                        <div className="bg-[#2c4a2c]/5 p-5 rounded-2xl" data-id="element-256">
                          <div className="w-12 h-12 bg-[#2c4a2c] text-white rounded-full flex items-center justify-center mx-auto mb-3 text-xl font-bold" data-id="element-257">
                            3
                          </div>
                          <h5 className="font-bold text-lg mb-2" data-id="element-258">
                            Carbo inteligente
                          </h5>
                          <p className="text-sm text-[#5a5a5a]" data-id="element-259">
                            Tipo + porción + momento. Los carbohidratos
                            correctos en el momento correcto.
                          </p>
                        </div>
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </motion.div>}
      </AnimatePresence>
    </Section>;
}